import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject23() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0.85rem 1.25rem;\n  border: none;\n  border-radius: 8px;\n  background-color: #27c763;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 600;\n  font-family: inherit;\n  text-transform: none;\n  letter-spacing: 0;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: #22b058;\n  }\n\n  &:active {\n    background-color: #1fa34f;\n  }\n"]);

  _templateObject23 = function _templateObject23() {
    return data;
  };

  return data;
}

function _templateObject22() {
  var data = _taggedTemplateLiteral(["\n  padding: 0 20px 20px;\n  display: flex;\n  justify-content: center;\n"]);

  _templateObject22 = function _templateObject22() {
    return data;
  };

  return data;
}

function _templateObject21() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px;\n  text-align: center;\n  font-size: 14px;\n  color: #333;\n  line-height: 1.4;\n"]);

  _templateObject21 = function _templateObject21() {
    return data;
  };

  return data;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr auto;\n  padding: 10px 10px 10px 20px;\n  color: white;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  background-color: #f76268;\n\n  p {\n    align-self: center;\n    text-align: left;\n    text-transform: uppercase;\n    margin: 0;\n    font-size: 14px;\n  }\n\n  div {\n    align-self: center;\n    cursor: pointer;\n  }\n\n  svg {\n    width: 25px;\n    display: block;\n  }\n"]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  width: 300px;\n  max-width: calc(100vw - 32px);\n  position: fixed;\n  top: 30%;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: white;\n  border-radius: 8px;\n  z-index: 99999999999;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  overflow: hidden;\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.35);\n  z-index: 9999999999;\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  z-index: 9999999999;\n"]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: 12px;\n  color: #666;\n"]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  color: #e30613;\n  font-size: 12px;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  font-size: 13px;\n  color: #666;\n  word-break: break-all;\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  align-self: flex-start;\n  padding: 0.65rem 1.25rem;\n  border: 2px solid #27c763;\n  border-radius: 8px;\n  background-color: #fff;\n  color: #27c763;\n  font-size: 14px;\n  font-weight: 600;\n  font-family: inherit;\n  text-transform: none;\n  letter-spacing: 0;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background-color: rgba(39, 199, 99, 0.08);\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n\n  @media (min-width: 480px) {\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: wrap;\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  max-width: 220px;\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #eee;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  font-size: 13px;\n  color: #555;\n  white-space: pre-wrap;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  font-size: 14px;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px;\n  border: 1px solid ", ";\n  border-radius: 8px;\n  cursor: pointer;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: auto;\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { styled } from "@styles";
export var Form = styled.form(_templateObject());
export var Wrapper = styled.div(_templateObject2());
export var ChannelList = styled.div(_templateObject3());
export var ChannelOption = styled.label(_templateObject4(), function (props) {
  return props.checked ? "#e30613" : "#e0e0e0";
});
export var ChannelBody = styled.div(_templateObject5());
export var ChannelTitle = styled.strong(_templateObject6());
export var ChannelDescription = styled.p(_templateObject7());
export var ChannelImage = styled.img(_templateObject8());
export var FileField = styled.div(_templateObject9());
export var FileLabel = styled.span(_templateObject10());
export var FileUploadRow = styled.div(_templateObject11());
export var HiddenFileInput = styled.input(_templateObject12());
export var UploadReceiptButton = styled.button(_templateObject13());
export var FileName = styled.span(_templateObject14());
export var ErrorText = styled.span(_templateObject15());
export var HelpText = styled.p(_templateObject16());
export var ModalRoot = styled.div(_templateObject17());
export var ModalOverlay = styled.div(_templateObject18());
export var ModalPanel = styled.div(_templateObject19());
export var ModalHeader = styled.div(_templateObject20());
export var ModalBody = styled.div(_templateObject21());
export var ModalFooter = styled.div(_templateObject22());
export var ModalActionButton = styled.button(_templateObject23());